export const CREATE_PRODUCT_TYPE = 'CREATE_PRODUCT_TYPE'
export const GET_LIST_PRODUCT_TYPE = 'GET_LIST_PRODUCT_TYPE'
export const DETAIL_PRODUCT_TYPE = 'DETAIL_PRODUCT_TYPE'
export const PATCH_PRODUCT_TYPE = 'PATCH_PRODUCT_TYPE'
